const TOKEN_KEY = '@auth';

export const setToken = (token: string):void => localStorage.setItem(TOKEN_KEY, token);
export const clearCredentials = ():void => localStorage.clear();
export const hasCredentials = ():boolean => !!localStorage.getItem(TOKEN_KEY);
export const getToken = ():string => localStorage.getItem(TOKEN_KEY) || '';
